class Action {
    actionId: number;
    ruleId: number;
    successFail: string;
    event: string;
    func: string;
    params: any[];

    constructor(actionId: number = 0) {
        this.actionId = actionId;
        this.ruleId = 0;
        this.successFail = "";
        this.event = "";
        this.func = "";
        this.params = [];
    }
}

export default Action;